import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/login',
    redirect: '/videos'
  },
  {
    path: '/',
    component: () => import('@/pages/layout'),
    children: [
      {
        path: '',
        redirect: '/videos'
      },
      {
        path: 'photos',
        name: 'Photos',
        meta: { title: '照片' },
        component: () => import('@/pages/photos')
      },
      {
        path: 'photos/upload',
        name: 'PhotoUpload',
        meta: { title: '上传照片' },
        component: () => import('@/pages/photos/upload')
      },
      {
        path: 'photos/:id',
        name: 'PhotoDetail',
        meta: { title: '照片详情' },
        component: () => import('@/pages/photos/detail')
      },
      {
        path: 'photos/:id/edit',
        name: 'PhotoEdit',
        meta: { title: '编辑照片' },
        component: () => import('@/pages/photos/edit')
      },
      {
        path: 'videos',
        name: 'Videos',
        meta: { title: '视频' },
        component: () => import('@/pages/videos')
      },
      {
        path: 'videos/upload',
        name: 'VideosUpload',
        meta: { title: '上传视频' },
        component: () => import('@/pages/videos/upload')
      },
      {
        path: 'videos/:id',
        name: 'VideoDetail',
        meta: { title: '视频详情' },
        component: () => import('@/pages/videos/detail')
      },
      {
        path: 'videos/:id/edit',
        name: 'VideoEdit',
        meta: { title: '编辑视频' },
        component: () => import('@/pages/videos/edit')
      },
      {
        path: 'recycle',
        name: 'Recycle',
        meta: { title: '回收站' },
        component: () => import('@/pages/recycle')
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    return { top: 0 }
  }
})

export default router
